// extracted by mini-css-extract-plugin
export default {"Container":"TabHeadingContainer_Container__80fU1","Tabs":"TabHeadingContainer_Tabs__1d0S8"};